<template>
  <div>
    <div class="d-flex align-center">
      <div
        class="gray-background-icon square-30 mr-2"
        v-if="hasChildren && !viewOnly"
        @click="toggled = !toggled"
      >
        <v-icon v-if="toggled">mdi-chevron-down</v-icon>
        <v-icon v-else>mdi-chevron-right</v-icon>
      </div>
      <LabeledText
        class="unit-item list-item"
        :class="{ hover: hover && !viewOnly }"
        :clickable="hasChildren"
        @mouseover.native="hover = true"
        @mouseleave.native="hover = false"
      >
        <template v-slot:icon> </template>
        <div class="d-flex align-center " @click="viewDetails(unit.id)">
          <div class="icon-wrapper" v-if="!viewOnly">
            <v-icon size="30px">mdi-cube-outline</v-icon>
          </div>
          <v-icon v-else class="mx-2" color="black" size="30px">
            mdi-cube-outline
          </v-icon>
          <div class="mr-2">{{ unit.name }}</div>
          <div class="secondary-text">
            {{ unit.costCode && `(${unit.costCode})` }}
          </div>
        </div>

        <template v-slot:action>
          <div v-show="(hover || isMobile) && !viewOnly">
            <Permissioned section="settings" :id="unit.id">
              <CreateUnitDialog
                v-if="open"
                :open="open"
                :initial-parent="unit"
                @close="open = false"
              />
              <PrimaryButton
                v-if="!isArchive"
                permission="create-organisation-unit"
                shrink
                @click="open = true"
              >
                <v-icon class="bold-icon" size="x-large">
                  mdi-plus
                </v-icon>
              </PrimaryButton>
              <RestoreUnitAction
                v-else
                permission="restore-organisation-unit"
                :unit="unit"
                @update="$emit('update')"
              />
            </Permissioned>
          </div>
        </template>
      </LabeledText>
    </div>
    <div class="unit-children" v-if="toggled || viewOnly">
      <OrganisationUnitItem
        toggledByFilter
        :viewOnly="viewOnly"
        :isArchive="isArchive"
        v-for="child in children"
        :key="child.id"
        :unit="child"
      />
    </div>
  </div>
</template>

<script>
import LabeledText from "@/components/common/BaseDetails/LabeledText";
import CreateUnitDialog from "@/views/settings/Organisation/Units/dialogs/CreateUnitDialog";
import Permissioned from "@/components/common/Permissioned";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import RestoreUnitAction from "@/views/settings/Organisation/Units/actions/RestoreUnitAction";

export default {
  name: "OrganisationUnitItem",
  components: {
    Permissioned,
    CreateUnitDialog,
    LabeledText,
    PrimaryButton,
    RestoreUnitAction
  },
  props: {
    unit: {
      type: Object,
      required: true
    },
    toggledByFilter: Boolean,
    viewOnly: Boolean,
    isArchive: Boolean
  },
  data() {
    return {
      toggled: this.toggledByFilter,
      hover: false,
      open: false
    };
  },
  computed: {
    hasChildren() {
      return !!this.children.length;
    },
    children() {
      return this.unit.organisationUnits || [];
    }
  },
  methods: {
    viewDetails(id) {
      if (!this.viewOnly && !this.isArchive) {
        this.$router.push({
          path: `/settings/organisation/${id}/units`
        });
      }
    }
  },
  watch: {
    toggledByFilter(val) {
      this.toggled = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.unit-item {
  padding: 2px 8px;
  border-radius: 50px 10px 10px 50px;
  .icon-wrapper {
    background-color: $selected-transparent;
  }
  &.hover {
    background-color: $background;
    display: flex;
    justify-content: row;
    cursor: pointer;
  }
  .actions {
    display: flex;
  }
}
.unit-children {
  margin-left: 1.5rem;
}
</style>
